const products_on_page_desktop = document.getElementById('blog-grid-desktop');
const products_on_page_mobile = document.getElementById('blog-grid-mobile');
const nextUrlDesktop = document.getElementById('paginateNextDesktop');
const nextUrlMobile = document.getElementById('paginateNextMobile');

// Determine the initial URL based on screen size
let isMobile = window.innerWidth <= 768; // Adjust breakpoint if necessary
let next_url = isMobile ? nextUrlMobile?.dataset.nextUrl : nextUrlDesktop?.dataset.nextUrl;

const load_more_btn_desktop = document.querySelector('.load-more-desktop .load-more_btn');
const load_more_btn_mobile = document.querySelector('.load-more-mobile .load-more_btn');
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

async function getNextPage() {
  try {
    if (!next_url) {
      console.error("No next URL found. Stopping fetch.");
      return null;
    }

    console.log("Fetching next_url =>", next_url);
    let res = await fetch(next_url);

    if (!res.ok) {
      console.error("Failed to fetch next page: HTTP", res.status);
      return null;
    }

    let text = await res.text();
    return text;
  } catch (error) {
    console.error("Error fetching next page:", error);
    return null;
  }
}

async function loadMoreProducts() {
  if (!next_url) {
    console.log("No next page available.");
    return;
  }

  const load_more_btn = isMobile ? load_more_btn_mobile : load_more_btn_desktop;
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';

  let nextPage = await getNextPage();

  if (!nextPage) {
    load_more_spinner.style.display = 'none';
    console.error("Failed to fetch next page content.");
    return;
  }

  // Create a temporary container and parse the fetched HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = nextPage;

  // Select the appropriate grid and pagination element
  isMobile = window.innerWidth <= 768;
  const productGrid = tempDiv.querySelector(isMobile ? '#blog-grid-mobile' : '#blog-grid-desktop');
  const newPaginateNext = tempDiv.querySelector(isMobile ? '#paginateNextMobile' : '#paginateNextDesktop');

  if (!productGrid) {
    console.error("No product grid found in the fetched page for", isMobile ? 'mobile' : 'desktop');
    load_more_spinner.style.display = 'none';
    return;
  }

  const new_url = newPaginateNext ? newPaginateNext.dataset.nextUrl : null;
  console.log("Extracted new next_url =>", new_url);

  // Update or remove the load more button depending on pagination
  if (new_url) {
    next_url = new_url;
    load_more_btn.style.display = 'flex';
  } else {
    console.log("No further pages available. Hiding load more button.");
    load_more_btn.style.display = 'none';
  }

  // Append the new products to the existing product list
  const products_on_page = isMobile ? products_on_page_mobile : products_on_page_desktop;
  const new_products = Array.from(productGrid.getElementsByClassName('blog-articles__article'));
  console.log("New products count =>", new_products.length);

  new_products.forEach(product => {
    products_on_page.appendChild(product);
  });

  // Hide spinner after loading
  load_more_spinner.style.display = 'none';
}

// Ensure responsiveness updates dynamically on window resize
window.addEventListener('resize', () => {
  isMobile = window.innerWidth <= 768;
  next_url = isMobile
    ? nextUrlMobile?.dataset.nextUrl
    : nextUrlDesktop?.dataset.nextUrl;

  products_on_page_mobile.style.display = isMobile ? 'flex' : 'none';
  products_on_page_desktop.style.display = isMobile ? 'none' : 'flex';
});
